module.exports = __webpack_public_path__ + "img/5.b5f033a0.jpg";